/**
 * processLauncher.js
 */

define(
        'processLauncher',
        ['jquery', 'bootbox', 'parameter', 'moment',
            'checkFeatures', 'number', "modal",
            'Seed', 'Seed.Tab', 'Seed.Ajax'],
        function ($, bootbox, parameter, moment, checkFeatures, number, modal, Seed) {
            "use strict";

            //    methods
            var OnClickEnabled = true;

            /**
             * Appeler une action SMaint
             * @param {int} numaction Numero de l'action
             * @param {array} param Tableau de paramètres
             * @param {array} paramui Tableau de champs de filtre
             * (input, select...)
             * @param {type} input
             * @param {bool} modeDebug Mode debug. Ouvrze le Manage.
             * @param {bool} forceNoReload Supprime le raffraichissement
             * de l'onglet
             * @param {type} forceNoRead
             * @param {bool} isImpr Check if it is impr button
             * @param {] selectedElem
             * @param {Boolean} isFromForm Check if it's called from a form
             */
            function process(
                    numaction,
                    param,
                    paramui,
                    input,
                    modeDebug,
                    forceNoReload,
                    forceNoRead,
                    isImpr,
                    selectedElem,
                    isFromForm,
                    event
              ) {

                if(typeof event === "undefined")
                  event = false;
                else if(typeof event.target.childNodes[0].className !== 'undefined')
                  if(event.target.childNodes[0].className.startsWith('fa fa-plus'))
                  event = true;
                  else
                    event = false;
                else
                  event = false;
                if (typeof isImpr === "undefined")
                  isImpr = false;
                if (!isFromForm)
                  if (selectedElem)
                    Seed.Tab.SetElementPosition(selectedElem);

                if (OnClickEnabled === false)
                  return 0;

                if (!modeDebug)
                    modeDebug = false;

                var sImport = "";
                var champRequisOk = true;
                if (param) {
                  var paramLength = param.length;
                  for (var i = 0; i < paramLength; i++) 
                    sImport += "&" + param[i][0] + "=" + param[i][1];
                }
                if (paramui) {
                  var paramuiLength = paramui.length;
                  var firstElementRequiered = "";
                  for (var i = 0; i < paramuiLength; i++) {
                    var uielement = $("#tab_" + Seed.Tab.cTab.attr("id")).find('#' + paramui[i][1]);
                    if (uielement.length === 0)
                      uielement = $("#tab_" + Seed.Tab.cTab.attr("id")).find('[id^=' + paramui[i][1] + '_]');
                    if (uielement.length !== 0) {
                      if ((uielement.val() === "") && (paramui[i][2] === "1") && isImpr === false) {
                        var parentGroup = $(uielement).parents('div.search-block');
                        $(parentGroup).addClass('has-error');
                        champRequisOk = false;
                        if (!firstElementRequiered)
                          firstElementRequiered = uielement;
                      }
                      var value = uielement.val();
                      if ($(uielement).hasClass('SM-datepicker') && value.length !== 0) 
                        value = moment.utc(value, 'L').toISOString();
                      sImport += "&" + paramui[i][0] + "=" + parameter.encodeParam(value);
                    }
                  }
                }

                if (champRequisOk === false && event === true) {
                    // Champ requis non renseigné
                    Seed.Tab.GetFrame().find('.collapse').collapse('show');
                    var box = bootbox.alert(MSG_CHAMP_REQUIS);

                    // Focus sur le 1er champ à renseigner
                    box.on('hidden.bs.modal', function () {
                        firstElementRequiered.focus();
                    });

                    return 0;
                } else {
                    // Zone en création
                    var searchform = Seed.Tab.GetFrame().find('div#recherche');
                    searchform.find('.has-error').removeClass('has-error');
                }

                if (modeDebug) {
                  var MngPath;
                  if (moduleType === "ServiceMaint")
                    MngPath = "../Manage/";
                  else if (moduleType === "ePortail")
                    MngPath = "../../EServices/Manage/";

                  var svgwindow = window.open(
                          MngPath + "index.php?"
                          + "draw=yes"
                          + "&action=" + numaction
                          + sImport
                          + "&moduleType=" + moduleType,
                          "name",
                          "menubar=no,resizable=yes,scrollbars=yes,"
                          + "toolbar=no,width=400,height=400"
                          );
                }

                processAction("action=" + numaction + sImport, input, forceNoReload, forceNoRead);
            }

            /**
             * Lancer une action
             * @param {string} sendrequest arguments à passer
             * @param {type} input
             * @param {bool} forceNoReload
             * @param {bool} forceNoRead
             * @returns {undefined}
             */
            function processAction(sendrequest, input, forceNoReload, forceNoRead)
            {
                var url = "Process.php";
                if ((typeof moduleType !== "undefined")
                        && (moduleType === "ePortail")) {
                    url = "../../EServices/source/" + url;
                } else if (moduleType === "Localisation") {
                    url = "../../" + url;
                }

                Seed.Ajax.Get({
                    url: url + "?" + sendrequest + "&moduleType=" + moduleType,
                    async: true,
                    success: function (Response) {
                        if (forceNoReload) {
                            Response = Response.replace('Seed.Tab.Reload();', '');
                        }

                        // Eviter refresh inutile car on a fait autre chose
                        // comme ouvrir un formulaire
                        if (Response.includes("require(")) {
                            Response = Response.replace('Seed.Tab.Reload();', '');
                        }
                        // Eviter double refresh
                        Response = Response.replace('Seed.Tab.Reload();Seed.Tab.Reload();', 'Seed.Tab.Reload();');

                        eval(Response);
                    }
                });
            }

            /**
             * @param {string} pNomTable Nom de la table concernée par l'update
             * @param {int} pIndex ID de l'élément
             * @param {string} pNomChamp Nom du champ à update
             * @param {mixed} pNouvelleValeur Valeur saisie par l'utilisateur
             * @param {array} pImport ???
             * @param {boolean} forceReload ???
             * @param {string} origine Contient l'origine de l'utilisateur (genre fr-FR)
             * @param {string} typechamp contient le type de champ
             * @returns {object}
             */
            function processUpdate(
                    pNomTable,
                    pIndex,
                    pNomChamp,
                    pNouvelleValeur,
                    pImport,
                    forceReload,
                    origine,
                    typechamp
                    ) {
                // Vérification du type d'entrée, si c'est un nombre
                // sans lettre on passe dans la fonction ParseNumber
                // Le champ origine a été rajouté à la fonction ProcessUpdate
                var numberSupport = checkFeatures.checkInput('number')
                        && checkFeatures.isSmallDevice();
                if (!numberSupport && (typechamp === 'nombre')) {
                    //On envoit la valeur et l'origine du user dans la fonction
                    // pour la formatter
                    pNouvelleValeur = number.parseNumber(pNouvelleValeur, origine);
                } else if (typechamp === 'date') {
                    if (pNouvelleValeur) {
                        var myDate = moment.utc(pNouvelleValeur, "L");
                        if (myDate.isValid() === false) {
                            myDate = moment.utc(pNouvelleValeur, "YYYY-MM-DD");
                        }
                        pNouvelleValeur = myDate.toISOString();
                    }
                } else if (typechamp === 'dateheure') {
                    var myDate = moment.utc(pNouvelleValeur, "L LT");
                    if (myDate.isValid() === false) {
                        pNouvelleValeur = pNouvelleValeur.replace('T', ' ');
                        myDate = moment.utc(
                                pNouvelleValeur,
                                "YYYY-MM-DD HH:mm"
                                );
                    }
                    if (pNouvelleValeur) {
                        pNouvelleValeur = myDate.toISOString();
                    }
                } else if (typechamp === 'heure') {
                    if (pNouvelleValeur) {
                        pNouvelleValeur = moment.utc(pNouvelleValeur, "LT")
                                .toISOString();
                        pNouvelleValeur = moment.utc(pNouvelleValeur).format('HH:mm:ss');
                    }
                }
                var send = "nomtable=" + pNomTable
                        + "&bbmindex=" + pIndex
                        + "&nomchamp=" + pNomChamp
                        + "&nouvellevaleur=" + encodeURIComponent(pNouvelleValeur);
                var responseText = Seed.Ajax.Post({
                    url: root + 'php_bdd/ProcessUpdate.php',
                    data: send
                });
                var numaction = responseText;
                // Exécution de l'arbre correspondant avec Process
                if (numaction != "NULL" && numaction !== "ERR") {
                    var ParamTable = [];
                    if (pImport) {
                        for (var i = 0; i < pImport.length; i++) {
                            ParamTable.push([pImport[i][0], pImport[i][1]]);
                        }
                    }

                    process(numaction, ParamTable, null, null);
                } else if (numaction === "ERR" || forceReload) {
                    Seed.Tab.Reload();
                    if (numaction === "ERR") {
                        bootbox.alert(MSG_IMPOSSIBLE_ACTION);
                    }
                }
            }

            /**
             * Lancement d'un process PHP
             * @param {string} URL URL du ficheir PHP
             * @param {array} param Tableau de paramètre à passer au PHP
             * @param {array} paramui  Tableau de paramètre à passer au PHP
             * @param {string} type Type d'ouverture : OpenModal, window, (vide)
             * @param {string} titre Titre de la fenêtre quand le choix est OpenModal
             */
            function processPHP(URL, param, paramui, type, titre)
            {
                var sImport = "";
                var champRequisOk = true;
                if (param) {
                    var paramLength = param.length;
                    for (var i = 0; i < paramLength; i++) {
                        param[i][1] = parameter.decodeParam(param[i][1]);
                        sImport += "&" + param[i][0] + "=" + encodeURIComponent(param[i][1]);
                    }
                }
                if (paramui) {
                    var paramuiLength = paramui.length;
                    for (var i = 0; i < paramuiLength; i++) {
                        var uielement = $("#tab_" + Seed.Tab.cTab.attr("id"))
                                .find('#' + paramui[i][1]);
                        if (uielement.length === 0) {
                            uielement = $("#tab_" + Seed.Tab.cTab.attr("id"))
                                    .find('[id^=' + paramui[i][1] + '_]');
                        }
                        if (uielement.length !== 0) {
                            if ((uielement.val() == "") && (paramui[i][2] == 1)) {
                                var parentGroup = $(uielement).parents('div.search-block');
                                $(parentGroup).addClass('has-error');
                                champRequisOk = false;
                            }

                            sImport += "&" + paramui[i][0] + "=" + encodeURIComponent(uielement.val());
                        } else {
                            alert("Element [" + paramui[i][1] + "] introuvable");
                        }
                    }
                }

                if (champRequisOk === false) {
                    Seed.Tab.GetFrame().find('.collapse').collapse('show');
                    bootbox.alert(MSG_CHAMP_REQUIS);
                    return 0;
                }

                if (type === 'OpenModal') {
                    URL = URL + '?' + sImport;
                    modal.openModalIframe(URL, titre);
                } else if (type === 'window') {
                    URL = URL + '?' + sImport;
                    window.location = URL;
                } else {
                    Seed.Ajax.Post({
                        url: URL,
                        data: sImport,
                        async: true,
                        success: function (response) {
                            eval(response);
                        }
                    });
                }
            }

            //    exposed public method
            return {
                process: process,
                processAction: processAction,
                processUpdate: processUpdate,
                processPHP: processPHP
            };
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);
